<template>
  <new-edit-page
    :page-title="$t('UpdateListItem')"
    :submit-button-label="$t('Save')"
    :submit-button-disabled="submitButtonDisabled"
    :is-loading="loading"
    @submit="editValue"
    one-section-only
  >
    <template v-slot:wholeSection>
      <list-value-form type="edit" :list-value-data="listValueData" />
    </template>
  </new-edit-page>
</template>

<script>
import { mapActions } from "vuex";
import NewEditPage from "../../../Management/NewEditPage/NewEditPage";
import utils from "@/utils";
import ListValueForm from "@/components/SystemManagement/SystemSettings/ListsSettings/ListItemForm";

export default {
  name: "UpdateListItem",

  components: {
    ListValueForm,
    NewEditPage
  },

  data() {
    return {
      listValueData: null,
      loading: true
    };
  },

  computed: {
    /**
     * Indicates if the submit button is disabled or not
     * @return {Boolean}
     */
    submitButtonDisabled() {
      return !(
        this.listValueData &&
        this.listValueData.code &&
        this.listValueData.libelle
      );
    }
  },

  mounted() {
    this.getListValues();
  },

  methods: {
    ...mapActions([
      "UPDATE_LIST_ITEM",
      "GET_LIST",
      "getCustomListValue",
      "editCustomListValue"
    ]),

    /**
     * Edits the list value
     * The executed methods are different because the BE endpoints are different
     */
    async editValue() {
      try {
        this.loading = true;
        let listName = this.$route.params.listName;
        let isCustomList = this.$route.params.isCustomList;

        if (isCustomList) {
          await this.editCustomListValue({
            newData: this.getDataToSend(),
            valueUuid: this.listValueData.uuid
          });
        } else {
          await this.UPDATE_LIST_ITEM({
            listName: listName,
            itemCode: this.listValueData.code,
            listValueData: this.getDataToSend()
          });
        }

        this.$router.back();
      } catch (error) {
        let errorMessage = utils.errorHandler(error);
        if (typeof errorMessage === "string") {
          this.$toasted.global.toast_error(errorMessage);
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * Returns an object with the data to send to the BE
     * If the value if from a custom list, only the code and libelle are sent
     * Else, the whole object is sent
     * @return {Object}
     */
    getDataToSend() {
      return this.$route.params.isCustomList
        ? {
            code: this.listValueData.code,
            libelle: this.listValueData.libelle
          }
        : {
            blocked: this.listValueData.blocked,
            client_code: this.listValueData.client_code,
            client_label: this.listValueData.client_label,
            definition: this.listValueData.definition,
            code: this.listValueData.code,
            index: this.listValueData.index,
            libelle: this.listValueData.libelle,
            deleted: this.listValueData.deleted
          };
    },

    /**
     * Gets the list value to edit
     */
    async getListValues() {
      try {
        let listName = this.$route.params.listName;
        let code = this.$route.params.item;
        let isCustomList = this.$route.params.isCustomList;

        if (isCustomList) {
          let valueList = await this.getCustomListValue(code);
          this.listValueData = valueList[0];
        } else {
          let valuesList = await this.GET_LIST({
            listName: listName,
            code: code
          });
          this.listValueData = valuesList.find(item => item.code == code);
          if (!this.listValueData.blocked) {
            this.listValueData.blocked = false;
          }
          if (!this.listValueData.deleted) {
            this.listValueData.deleted = false;
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SystemManagement/SystemSettings/ListsSettings/UpdateListItem.vue